exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-e705c98c] .md-menu-content.md-select-menu {\n  width: 150px;\n}\n.modal-container[data-v-e705c98c] {\n  max-width: 600px;\n}\n", ""]);

// exports
